<h1>Customer Service</h1>

<section>
<p>For IDS Software License Inquiries: 1-800-ROTUNDA (800-768-8632), option 1
<p>To purchase IDS Hardware: 1-800-ROTUNDA (800-768-8632), option 2
<!-- <p>For Hardware and Software Technical Issues: 1-888-354-7558 (Monday-Friday 8:00AM to 8:00PM EST) -->
</section>
